module.exports = __webpack_public_path__ + "static/media/warning.d88b36f0.gif";